import React from "react";
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import Header from "../../AdminComponents/Header";
import { useDispatch, useSelector } from "react-redux";
import "./CreateCordinator.css";

const {
  co_ordinatorRegister,
} = require("../../../../context/Slice/RegisterSlice");

const CreateCoordinator = ({ handleFormClose, refreshUserList }) => {
  const Dispatch = useDispatch();

  const validationSchema = yup.object({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
    mobile_number: yup.string().required("Mobile Number is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      mobile_number: "",
      role_type: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const response = await Dispatch(co_ordinatorRegister(values));
      console.log("response", response.payload);
      refreshUserList();
      handleFormClose();
    },
  });


  return (
    <Box m="20px">
      <Header
        title="Create New Coordinator"
        subtitle="Create a New Coordinator Profile"
      />

      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <Box
          className="form-container"
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="First Name"
            name="firstName"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 2" }}
            className="text-field"
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Last Name"
            name="lastName"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 2" }}
            className="text-field"
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 4" }}
            className="text-field"
          />
          <TextField
            fullWidth
            variant="filled"
            type="password"
            label="Password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 4" }}
            className="text-field"
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Mobile Number"
            name="mobile_number"
            value={formik.values.mobile_number}
            onChange={formik.handleChange}
            error={
              formik.touched.mobile_number &&
              Boolean(formik.errors.mobile_number)
            }
            helperText={
              formik.touched.mobile_number && formik.errors.mobile_number
            }
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 4" }}
            className="text-field"
          />
          <FormControl style={{ minWidth: 200 }}>
            <InputLabel>Select Role</InputLabel>
            <Select
              name="role_type"
              value={formik.values.role}
              onChange={formik.handleChange}
            >
              <MenuItem value="Master">Master</MenuItem>
              <MenuItem value="Employee">Employee</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          className="form-button-container"
          display="flex"
          justifyContent="center"
          mt="20px"
        >
          <Button
            type="submit"
            variant="contained"
            className="fs-3"
            sx={{ mr: 2 }}
          >
            Add
          </Button>
          <Button
            type="button"
            variant="contained"
            className="fs-3"
            onClick={handleFormClose}
          >
            Back
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreateCoordinator;
